import { render } from "./NewDeclarationVersion.vue?vue&type=template&id=6bd9d67a"
import script from "./NewDeclarationVersion.vue?vue&type=script&lang=js"
export * from "./NewDeclarationVersion.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__